import moment from "moment";

export default {
  data() {
    return {
      storeName: "",
      title: "",
      labelSubmit: this.$route.params.id ? "Actualizar" : "Crear",
      labelCancel: "Cancelar",
      filteredAttributes: [],
      data: {
        id: "",
      },
      parentUrlKey: "",
      parentStoreName: "",
    };
  },
  created() {
    this.loadCreatedGlobal();
    /* const self = this;
    if (this.$route.params.id) {
      this.$store
        .dispatch(`${this.storeName}/show`, this.$route.params.id)
        .then(function (data) {
          for (let i in data) {
            if (
              self.data[i] !== undefined &&
              !self.filteredAttributes.includes(i)
            ) {
              self.data[i] = data[i];
            } else {
              if (
                self.filteredAttributes.includes(i) &&
                self[i] !== undefined
              ) {
                self[i] = data[i];
              }
            }
          }
          self.onCreate(data);
        });
    } */
  },
  methods: {
    loadCreatedGlobal() {
      const self = this;
      if (this.$route.params.id) {
        this.$store
          .dispatch(`${this.storeName}/show`, this.$route.params.id)
          .then(function (data) {
            for (let i in data) {
              if (
                self.data[i] !== undefined &&
                !self.filteredAttributes.includes(i)
              ) {
                self.data[i] = data[i];
              } else {
                if (
                  self.filteredAttributes.includes(i) &&
                  self[i] !== undefined
                ) {
                  self[i] = data[i];
                }
              }
            }
            self.onCreate(data);
          });
      }
    },
    onCreate: Function,
    buildRootUrl() {
      if (this.parentUrlKey && this.parentStoreName) {
        return (
          "/admin/" +
          this.parentStoreName.toLowerCase() +
          "/" +
          this.$route.params[this.parentUrlKey] +
          "/" +
          this.storeName.toLowerCase()
        );
      } else {
        return "/admin/" + (this.parentStoreUrl || this.storeName.toLowerCase());
      }
    },
    async submit() {
      const self = this;
      let valid = await self.$refs.validator.validate();
      if (valid) {
        let saveUrl = this.$route.params.id
          ? `${this.storeName}/update`
          : `${this.storeName}/create`;
        self.$store
          .dispatch(saveUrl, self.data)
          .then(function () {
            self.$router.push(self.buildRootUrl());
          })
          .catch(function (response) {
            if (response && response.message && Object.keys(response.message).length > 0) {
              for (const itemRef of Object.keys(response.message)) {
                if (self.$refs[itemRef] && response.message[itemRef] && response.message[itemRef].length > 0) {
                  self.$refs[itemRef].setErrors(response.message[itemRef][0]);
                }
              }
            }
            if (self.$refs.seat_quantity) self.$refs.seat_quantity.setErrors([]);
            console.log('response', response);
            if (response?.message) {
              if (typeof response.message === "string") {
                self.$refs.seat_quantity?.setErrors([response.message]);
              } else if (response.message.seat_quantity) {
                // Si el backend eventualmente manda un objeto con seat_quantity
                self.$refs.seat_quantity?.setErrors([response.message.seat_quantity]);
              }
            }

            if (response && response.message && response.message.patent) {
              eval("self.$refs." + "patent" + ".setErrors(response.message.patent[0]);");
            }

            for (const i in response.errors) {

              try {
                // eval("self.$refs." + i + ".setErrors(response.errors[i]);");
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
      }
    },
    formatDateForSave(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}-${day}-${year}`;
    },
    formatDateTime(created_at) {
      if (!created_at) return null;
      let [date, time] = created_at.split("T");
      const [year, month, day] = date.split("-");
      time = (time.split(".")[0]);
      return `${day}/${month}/${year} ${time}`;
    },
    formatDate(created_at) {
      if (!created_at) return null;
      let [date, time] = created_at.split("T");
      const [year, month, day] = date.split("-");
      time = (time.split(".")[0]);
      return `${day}/${month}/${year}`;
    },
    formatDateMoment(date) {
      if (!date) return null;
      return moment(date).format("DD/MM/YYYY");
    },
    formatDateTimeMoment(date) {
      if (!date) return null;
      return moment(date).format("DD/MM/YYYY HH:mm:ss");
    },
    formatDateTimeUtc3(date) {
      if (!date) return null;

      const d = new Date(date);

      // Convertimos a milisegundos y aplicamos offset UTC-3
      const utcMinus3 = new Date(d.getTime() - 3 * 60 * 60 * 1000);

      const pad = (num) => String(num).padStart(2, '0');

      const day = pad(utcMinus3.getUTCDate());
      const month = pad(utcMinus3.getUTCMonth() + 1);
      const year = utcMinus3.getUTCFullYear();

      const hours = pad(utcMinus3.getUTCHours());
      const minutes = pad(utcMinus3.getUTCMinutes());
      const seconds = pad(utcMinus3.getUTCSeconds());

      return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
  },
};
